import { FormField, Select, Option } from '@sede-enterprise/shell-ds-react-framework';
import React, { Dispatch, SetStateAction } from 'react';

type DispatchType =
  | Dispatch<SetStateAction<string>>
  | Dispatch<SetStateAction<number>>
  | Dispatch<SetStateAction<string[]>>
  | Dispatch<SetStateAction<number[]>>;
type OnChangeType = DispatchType | ((e: string[]) => void);

interface SelectFormFieldProps {
  id: string;
  label: string;
  testId: string;
  value: string | number | Array<string | number>;
  onChange: OnChangeType;
  options:
    | Array<{
        label: string | number;
        value: string | number;
      }>
    | Array<string | number>;
  mode?: 'single' | 'multiple';
  disabled?: boolean;
}

export const SelectFormField: React.FC<SelectFormFieldProps> = ({
  id,
  label,
  testId,
  value,
  onChange,
  options,
  mode = 'single',
  disabled = false,
}) => (
  <FormField id={id} label={label} data-testid={testId}>
    <Select
      size='medium'
      allowClear={false}
      aria-label='Select'
      value={value ?? undefined}
      onChange={onChange}
      mode={mode}
      disabled={disabled}
    >
      {options
        ? options.map((el) => {
            const option =
              typeof el === 'string' || typeof el === 'number' ? { label: el, value: el } : el;
            return (
              option && (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              )
            );
          })
        : null}
    </Select>
  </FormField>
);
